"use strict";

Shopify.theme.jsCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsCollection = $.extend(this, Shopify.theme.getSectionData($section)); //Ensure product media libraries are present

    window.Shopify.loadFeatures([{
      name: 'model-viewer',
      version: '0.8'
    }, {
      name: 'shopify-xr',
      version: '1.0'
    }, {
      name: 'model-viewer-ui',
      version: '1.0'
    }]);

    //this.createGallery($section);
    
    if ($(window).width() < 813) {
//       mobile
      var tiles = localStorage.getItem('collection__tiles-setting') != null ? localStorage.getItem('collection__tiles-setting') : 'nine-tiles';
      $('.collection-matrix').addClass(tiles);
      $('.collection__gallery-switcher button[data-number='+tiles+']').addClass('active');
    } else {
      var tiles = localStorage.getItem('collection__tiles-setting') != null ? localStorage.getItem('collection__tiles-setting') : 'nine-tiles';
      $('.collection-matrix').addClass(tiles);
      $('.collection__gallery-switcher button[data-number='+tiles+']').addClass('active');
    }    
    
    var sidebar = $('.shopify-section.collection-sidebar');
    var sidebar_pos = localStorage.getItem('collection__sidebar-closed');
    sidebar.addClass(sidebar_pos);
      $('.collection-matrix').addClass('sidebar-'+sidebar_pos);
      if($('.collection-matrix').hasClass('sidebar-closed')){
        $('.jsCollection').addClass('full');
        $('.sidebar-drop-wrap').addClass('drop-off');
      }



    $('.collection__sidebar-switcher').on('click', function () {

      let data_sidebar = $('.collection__sidebar-switcher');
      let icon_text = $('.collection__sidebar-switcher > span');
      // data_sidebar.attr('data-sidebar', (_, attr) => attr === 'closed' ? 'open' : 'closed');


      data_sidebar.attr('colspan', function (index, attr) {
        if (attr === 'closed') {
          icon_text.text(' ausblenden');
          // icon_text.animate({'opacity': 1}, );
          return 'opened';
        } else {
          icon_text.text(' einblenden');
          return 'closed';
        }

      });

      $('.sidebar-drop-wrap').toggleClass('drop-off');

      $('.collection-matrix').toggleClass('sidebar-closed');
      $('.jsCollection').toggleClass('full');

      sidebar.toggleClass('closed');
      localStorage.setItem('collection__sidebar-closed', sidebar.hasClass('closed') ? 'closed' : 'opened');
    });

    
    $('.collection__gallery-switcher button').on('click', function(){
      var t = $(this).data('number');
      $('.collection__gallery-switcher button').removeClass('active');
      $(this).addClass('active');
      localStorage.setItem('collection__tiles-setting',t);
      $('.collection-matrix').removeClass('four-tiles').removeClass('nine-tiles').addClass(t);
    });
    
    $('.collection-top-bar .sidebar-block__item').on('mouseenter',function(){
      $(this).find('.collection__dropdow-menu').addClass('opened');
    });
    $('.collection-top-bar .sidebar-block__item').on('mouseleave',function(){
      $(this).find('.collection__dropdow-menu').removeClass('opened');
    });

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function () {
        Shopify.theme.jsCollection.filterURL();
      });
    }

    // $('.recyclable-sticker').on('click',function(e){
    //   e.preventDefault();
    //   $('.recyclable-popup').css({'opacity':'0'});
    //   $(this).parent().find('.recyclable-popup').css({'opacity':'1'});
    // });
    // $(document).mouseup(function(e)
    // {
    //   var container = $(".product-wrap");

    //   if(!$(".recyclable-sticker").is(e.target)) {
    //     if (!container.is(e.target)) {
    //       $('.recyclable-popup').css({'opacity':'0'});
    //     }
    //   }
    // });

    // document.addEventListener("scroll", function() {
    //   $('.recyclable-sticker').on('click',function(e){
    //     e.preventDefault();
    //     $('.recyclable-popup').css({'opacity':'0'});
    //     $(this).parent().find('.recyclable-popup').css({'opacity':'1'});
    //   });
    //   $(document).mouseup(function(e)
    //   {
    //     var container = $(".product-wrap");

    //     if(!$(".recyclable-sticker").is(e.target)) {
    //       if (!container.is(e.target)) {
    //         $('.recyclable-popup').css({'opacity':'0'});
    //       }
    //     }
    //   });
    // });




    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-option-filter].active').each(function () {
        Shopify.theme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      });
    } // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object


    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      Shopify.theme.breadcrumbs.init(this.number_of_pages);
    }
    /* Collection sidebar filter */


    $('body').on('click', '[data-option-filter]', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      Shopify.theme.jsCollection.multiTagFilter.init($(this));
    });
    $('body').on('click', '[data-clear-filter]', function () {
      var $el = $(this).siblings('[data-option-filter]');
      var $productTagFilter = $('#tag_filter');
      $productTagFilter.find('option:eq(0)').prop('selected', true);
      Shopify.theme.jsCollection.multiTagFilter.clearSelectedFilter($el);
    });

    function detectMob() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some(function(toMatchItem) {
        return navigator.userAgent.match(toMatchItem);
      });
    }

    if(!detectMob()) {
      var sortWrapper = $('.collection__sort-by-filter');
      var oldSelect = $('#sort-by');

      sortWrapper.append("<div class='custom-select'></div>");
      oldSelect.children('option').each(function () {
        $('.collection__sort-by-filter .custom-select').append("<div class='custom-select-option' data-value='" + $(this).val() + "'><span>" + $(this).text() + "</span></div>");
      });
      oldSelect.on('mousedown', function (e) {
        e.preventDefault();
        $('.collection__sort-by-filter .custom-select').slideToggle('fast');
        sortWrapper.toggleClass('opened');
      });

      $('.collection__sort-by-filter .custom-select .custom-select-option').on('click', function () {
        oldSelect.val($(this).data('value'));
        $('.collection__sort-by-filter .custom-select').slideUp('fast');
        $(".collection__sort-by-filter select").css({'width': $(this).find('span').width()+50+'px'});
   
        sortWrapper.removeClass('opened');
        Shopify.theme.jsCollection.filterURL();
      });
      var width_element = $('.custom-select-option[data-value='+url('?sort_by')+'] span');
      	$('.custom-select').css({ position: "absolute", visibility: "hidden", display: "block" });
        var elemWidth = width_element.outerWidth();
        $('.custom-select').css({ position: "", visibility: "", display: "none" });
        $(".collection__sort-by-filter select").css({'width': elemWidth+50+'px'});
      
    } else {
      $(".collection__sort-by-filter select").on('focus', function(){
        $(".collection__sort-by-filter").addClass('opened');
      });
      $(".collection__sort-by-filter select").on('focusout', function(){
        $(".collection__sort-by-filter").removeClass('opened');
        var selected = $(".collection__sort-by-filter select option:selected").val();
        $(".collection__sort-by-filter select").css({'width': $('.collection__sort-by-filter .custom-select').find('.custom-select-option[data-value='+selected+'] span').width()+10+'px'});

      });

      $(".collection__sort-by-filter").append("<div class='custom-select' style='opacity:0;display: block; position: absolute;font-size: 16px;line-height: 32px;'></div>");
      $(".collection__sort-by-filter select").children('option').each(function () {
        $('.collection__sort-by-filter .custom-select').append("<div class='custom-select-option' data-value='" + $(this).val() + "'><span>" + $(this).text() + "</span></div>");
      });

      var selected = $(".collection__sort-by-filter select option:selected").val();
      $(".collection__sort-by-filter select").css({'width': $('.collection__sort-by-filter .custom-select').find('.custom-select-option[data-value='+selected+'] span').width()+10+'px!important'});
    }

  },
  filterURL: function filterURL() {
    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname'),
        url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
        url2 = $.url('2') ? $.url('2') + '/' : '',
        url3 = $.url('3') ? $.url('3') + '/': '',
        path = url1 + url2 + url3; //Handle dropdowns if they exist

    if ($('#sort-by').length) {
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length) {
      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()) {
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all') {
          if ($.inArray(urlTag, selectedOptions) > -1) {//Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    } //Add all checkbox values to array


    $('[data-option-filter].active').each(function () {
      selectedOptions.push($(this).data('option-filter'));
    });
    selectedOptions = $.makeArray(selectedOptions); //Loop through tags to create string to update page url

    $.each(selectedOptions, function (i, value) {
      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }
    });
    var q = query;
    Shopify.theme.queryParameters.sort_by = q;
    query = '?';
    if(q !== null){
    query += $.param(Shopify.theme.queryParameters);
    }
    this.processUrl(path, currentTags, query);
  },
  processUrl: function processUrl(path, tags, query) {
    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';
    urlString = path + tags + query;
    this.updateView(urlString);
  },
  createGallery: function createGallery($section){
    var $productGallery = $section.find('.product-gallery__main');
    if ($productGallery) {

      $productGallery.find('.gallery-cell:not(.product-gallery__image)').addClass('product-gallery__image'); // Adds 'product-gallery__thumbnail' class if not present

      var $slides = $productGallery.find('.product-gallery__image');
      var arrowsEnabled;
      var slideshowSpeed;
      var slideshowTransition;

      slideshowSpeed = 0;
      slideshowTransition = 'slide';

      // $productGallery.on('ready.flickity', function () {
      //   $slides.each(function (index, slide) {
      //     //Determine media type
      //     var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
      //     var videoID;
      //     var videoLooping = $('[data-video-loop]').data('video-loop');
      //
      //     switch (mediaType) {
      //       case 'external_video':
      //         videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');
      //
      //         if (videoPlayers) {
      //           for (var i = 0; i < videoPlayers.length; i++) {
      //             if (videoPlayers[i].id == videoID || videoPlayers[i].media.id == videoID) {
      //               videoPlayers[i].loop = videoLooping;
      //
      //               if (!$(slide).hasClass('is-selected')) {
      //                 videoPlayers[i].keyboard = {
      //                   focused: false,
      //                   global: false
      //                 };
      //               }
      //             }
      //           }
      //         }
      //
      //         break;
      //
      //       case 'video':
      //         videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');
      //
      //         if (videoPlayers) {
      //           for (var _i = 0; _i < videoPlayers.length; _i++) {
      //             if (videoPlayers[_i].id == videoID || videoPlayers[_i].media.id == videoID) {
      //               videoPlayers[_i].loop = videoLooping;
      //
      //               if (!$(slide).hasClass('is-selected')) {
      //                 videoPlayers[_i].keyboard = {
      //                   focused: true,
      //                   global: false
      //                 };
      //               }
      //             }
      //           }
      //         }
      //
      //         break;
      //
      //       // case 'model':
      //       //   if ($(slide).hasClass('is-selected')) {
      //       //     //When active slide
      //       //     if (mediaType == 'model' && isScreenSizeLarge()) {
      //       //       $(slide).on('mouseenter', function () {
      //       //         $productGallery.flickity('unbindDrag');
      //       //       });
      //       //       $(slide).on('mouseleave', function () {
      //       //         $productGallery.flickity('bindDrag');
      //       //       });
      //       //     }
      //       //   }
      //
      //     } // Detect keyboard 'ENTER' key on slides
      //
      //
      //     $(slide).keypress(function (event) {
      //       if (event.which == 13) {
      //         // Bring focus to media inside selected slide
      //         $(slide).find('model-viewer, .product-gallery__link, .plyr').focus(); // Run video autoplay logic if featured media is a video
      //
      //         if (mediaType == 'video' || mediaType == 'external_video') {
      //           checkForVideos();
      //         } // Autoplay model if featured media is a model
      //
      //
      //         // if (mediaType == 'model') {
      //         //   // If model container has class is-selected then play the model
      //         //   autoplayModel();
      //         // }
      //       }
      //     });
      //   });
      // });
      var productGallerySlider = new Swiper('.gallery-container.swiper-container', {
        // Optional parameters
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        grabCursor: true,
        spaceBetween: 0,
        navigation: {
          nextEl:  '.swiper-button.next',
          prevEl: '.swiper-button.previous',
        },
        on: {
          init: function(){
            $slides.each(function (index, slide) {
              //Determine media type
              var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
              var videoID;
              var videoLooping = $('[data-video-loop]').data('video-loop');

              switch (mediaType) {
                case 'external_video':
                  videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

                  if (videoPlayers) {
                    for (var i = 0; i < videoPlayers.length; i++) {
                      if (videoPlayers[i].id == videoID || videoPlayers[i].media.id == videoID) {
                        videoPlayers[i].loop = videoLooping;

                        if (!$(slide).hasClass('swiper-slide-active')) {
                          videoPlayers[i].keyboard = {
                            focused: false,
                            global: false
                          };
                        }
                      }
                    }
                  }

                  break;

                case 'video':
                  videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

                  if (videoPlayers) {
                    for (var _i = 0; _i < videoPlayers.length; _i++) {
                      if (videoPlayers[_i].id == videoID || videoPlayers[_i].media.id == videoID) {
                        videoPlayers[_i].loop = videoLooping;

                        if (!$(slide).hasClass('swiper-slide-active')) {
                          videoPlayers[_i].keyboard = {
                            focused: true,
                            global: false
                          };
                        }
                      }
                    }
                  }

                  break;

                  // case 'model':
                  //   if ($(slide).hasClass('is-selected')) {
                  //     //When active slide
                  //     if (mediaType == 'model' && isScreenSizeLarge()) {
                  //       $(slide).on('mouseenter', function () {
                  //         $productGallery.flickity('unbindDrag');
                  //       });
                  //       $(slide).on('mouseleave', function () {
                  //         $productGallery.flickity('bindDrag');
                  //       });
                  //     }
                  //   }

              } // Detect keyboard 'ENTER' key on slides


              $(slide).keypress(function (event) {
                if (event.which == 13) {
                  // Bring focus to media inside selected slide
                  $(slide).find('model-viewer, .product-gallery__link, .plyr').focus(); // Run video autoplay logic if featured media is a video

                  if (mediaType == 'video' || mediaType == 'external_video') {
                    checkForVideos();
                  } // Autoplay model if featured media is a model


                  // if (mediaType == 'model') {
                  //   // If model container has class is-selected then play the model
                  //   autoplayModel();
                  // }
                }
              });
            });
          }
        },
        slideChange: function(){

          $slides.each(function (index, slide) {
            //Determine media type of current slide
            var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

            if (!$(slide).hasClass('swiper-slide-active')) {
              // //When active slide
              // switch (mediaType) {
              //   case 'model':
              //     /* On slide change, if active slide contains 3d model
              //     * If on desktop, on hover, unbind flickity, after hover bind flickity
              //     * On model play event, unbind flickity to ensure model can be interacted with
              //     * On model pause event, bind flickity so that slide can be swiped
              //     * Pause all model slides when hidden
              //     */
              //     if (isScreenSizeLarge()) {
              //       // On mouseenter event, unbind flickity
              //       $(slide).on('mouseenter', function () {
              //         $productGallery.flickity('unbindDrag');
              //       }); // On mouseleave event, bind flickity
              //
              //       $(slide).on('mouseleave', function () {
              //         $productGallery.flickity('bindDrag');
              //       });
              //     } // Listen for model pause/play events
              //
              //
              //     $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {
              //       $productGallery.flickity('unbindDrag');
              //     });
              //     $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function () {
              //       $productGallery.flickity('bindDrag');
              //     });
              //     break;
              //
              //   default:
              //     $productGallery.flickity('bindDrag');
              //}
              //} else {
              //When inactive slide
              switch (mediaType) {
                case 'external_video':
                  //Youtube video pausing
                  $.each(videoPlayers, function (index, player) {
                    player.pause();
                  });
                  break;

                case 'video':
                  //HTML5 video pausing
                  $.each(videoPlayers, function (index, player) {
                    player.pause();
                  });
                  break;

                  // case 'model':
                  //   $.each(Shopify.theme.productMedia.models, function (index, model) {
                  //     model.pause();
                  //   });
              }
            }
          }); //Restore 3d model icons

          Shopify.theme.productMedia.showModelIcon($productGallery);
        }
      });
      // $productGallery.flickity({
      //   wrapAround: true,
      //   adaptiveHeight: true,
      //   dragThreshold: 10,
      //   imagesLoaded: true,
      //   pageDots: false,
      //   prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1 ? true : false,
      //   autoPlay: slideshowSpeed * 1000,
      //   fade: slideshowTransition === 'fade' ? true : false,
      //   watchCSS: this.template === 'image-scroll' ? true : false,
      //   arrowShape: arrowShape
      // });
      // Autoplay logic only happens on desktop, autoplay set to off for mobile

      var $sliderArrows = $('.gallery-container').find('.swiper-button');

      if ($sliderArrows && isScreenSizeLarge()) {
        $sliderArrows.on('click', function () {
          productGallerySlider.on('slideChangeTransitionEnd', function (event, index) {
            // Find out media type of featured media slide
            var $selectedSlide = $productGallery.find('.product-gallery__image.swiper-slide-active');
            var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
            var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

            if (mediaType == 'video' || mediaType == 'external_video') {
              checkForVideos();
            } // Autoplay model if featured media is a model


            // if (mediaType == 'model') {
            //   // Sort models to get those in selected slide
            //   var sortedModels = [];
            //   $.each(Shopify.theme.productMedia.models, function (index, model) {
            //     if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
            //       sortedModels.push(model);
            //     }
            //   }); // If model container has class is-selected then play the model
            //
            //   $.each(sortedModels, function (index, model) {
            //     var $slide = $(model.container).parents('.product-gallery__image');
            //
            //     if ($slide.hasClass('is-selected')) {
            //       model.play();
            //     }
            //   });
            // }

            $productGallery.off('settle.flickity');
          });
          return false;
        });
      }
    }
  },
  updateView: function updateView(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function beforeSend() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      success: function success(data) {},
      error: function error(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      },
      dataType: "html"
    }).then(function (data) {
      var $breadcrumbContainer = $('.breadcrumb__container');
      var $collectionMatrix = $('.collection-matrix');
      var $collectionMain = $('.collection__main'); // Get and set new breadcrumb html

      var filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb); // Remove loading animation

      $collectionMatrix.removeClass('fadeIn animated loading-in-progress'); // Check for products

      var filteredData = $(data).find('.collection-matrix__wrapper');
      var filteredPageLinks = $(data).find('.container--pagination');
      var noProducts = $(data).find('.container--no-products-in-collection');

      if (filteredData.length) {
        // Add products to container
        $collectionMain.empty();
        $collectionMain.append(filteredData);
      } else {
        // Display no product message
        $collectionMain.empty();
        $collectionMain.append(noProducts);
      }
      
      $('.collection__count').text($(data).find('.product__thumbnail').length + ' ' + Shopify.translation.collection_count);

      $collectionMain.append(filteredPageLinks);
      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      if (Shopify.theme_settings.enable_shopify_collection_badges == true) {
        Shopify.theme.productReviews();
      }

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
      Shopify.theme.infiniteScroll.init();

      Shopify.theme.jsCollection.createGallery($('body'));

    });
  },
  multiTagFilter: {
    init: function init($el) {
      // Show filter and hide siblings
      this.showSelectedFilter($el); // Update url

      Shopify.theme.jsCollection.filterURL(); // Hide filters if types or vendors is in URL (can't be combined)

      if ($.url(2) === 'types' || $.url(2) === 'vendors') {
        $('.block__tag-filter').remove();
      }
    },
    showSelectedFilter: function showSelectedFilter($el) {
      var $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      var $filterItem = $el.parents('.tag-filter__item');
      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden'); // If sidebar toggle is enabled, show filter in sidebar content

      if ($sidebarToggleBlock.length) {
        var $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');
        Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
      }
    },
    clearSelectedFilter: function clearSelectedFilter($el) {
      var $filterItem = $el.parents('.tag-filter__item');
      $filterItem.removeClass('is-active').find('input').prop("checked", false);
      $filterItem.siblings().removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]').addClass('is-hidden'); //Update url

      Shopify.theme.jsCollection.filterURL();
    }
  },
  unload: function unload($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    Shopify.theme.breadcrumbs.unload();
  }
};